module.exports = __webpack_public_path__ + "img/template4.ea709244.svg";